import { ColumnConfig } from './column-config';
import { ColumnExtractor } from './extractors/column-extractor';
import { ExtractorConfig } from './table-data-extractors/extractor-config';

/*******************************************
 * HERE BE DRAGONS - NO DISPLAY COMPONENT SPECIFIC LOGIC ALLOWED
 * Under no circumstances DO NOT change the code below if it looks like it doesn't do what you need it to do.
 * Consult the team if there's functionality missing !!!
 *******************************************/

export class TabConfig {
	public static create(options: TabConfigOptions): TabConfig {
		return new TabConfig(options.id, options.title, options.extractorConfig);
	}
	constructor(public readonly id: string, public readonly title: ColumnConfig<ColumnExtractor>, public readonly extractorConfig: ExtractorConfig) { }
}

export interface TabConfigOptions {
	id: string;
	title: ColumnConfig<ColumnExtractor>;
	extractorConfig: ExtractorConfig;
}
